document.querySelectorAll('[data-carni-hero]').forEach(function (root) {
  var DURATION = 6000;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var inView = true;
  var slides = root.querySelectorAll('.carni-hero__slide');
  var dotsWrap = root.querySelector('.carni-hero__dots');
  if (!dotsWrap || !slides.length) return;
  var i = 0, timer;
  slides.forEach(function (s, idx) {
    s.inert = idx !== 0;
    s.setAttribute('aria-hidden', idx === 0 ? 'false' : 'true');
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'carni-hero__dot' + (idx === 0 ? ' is-active' : '');
    d.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
    d.innerHTML = '<span class="carni-hero__dot-fill"></span>';
    d.addEventListener('click', function () { go(idx); reset(); });
    dotsWrap.appendChild(d);
  });
  var dots = dotsWrap.querySelectorAll('.carni-hero__dot');
  // Progress-bar fill: past dots full, future empty, current animates 0 -> 100% over DURATION.
  function paint() {
    dots.forEach(function (d, idx) {
      var fill = d.querySelector('.carni-hero__dot-fill');
      d.classList.toggle('is-active', idx === i);
      if (!fill) return;
      fill.style.width = '100%';
      fill.style.transformOrigin = 'left';
      fill.getAnimations().forEach(function (animation) { animation.cancel(); });
      fill.style.transition = 'none';
      fill.style.transform = idx <= i ? 'scaleX(1)' : 'scaleX(0)';
      if (idx === i && !slides[i].querySelector('[data-carni-reveal]') && !motion.matches && !document.hidden && inView) {
        fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration: DURATION, easing: 'linear', fill: 'forwards' });
      }
    });
  }
  function go(n) {
    slides[i].classList.remove('is-active');
    slides[i].inert = true;
    slides[i].setAttribute('aria-hidden', 'true');
    i = (n + slides.length) % slides.length;
    slides[i].classList.add('is-active');
    slides[i].inert = false;
    slides[i].setAttribute('aria-hidden', 'false');
    paint();
  }
  var resumeT;
  function reset() { clearTimeout(resumeT); clearInterval(timer); if (motion.matches || document.hidden || !inView || slides.length < 2) return; timer = setInterval(function () { if (!slides[i].querySelector('[data-carni-reveal]')) go(i + 1); }, DURATION); }
  // Pause the auto-advance while the visitor is engaging (holding a slide, scrolling a card
  // row); resume shortly after they stop, restarting the current dot's progress animation.
  function pause() { dotsWrap.querySelectorAll('.carni-hero__dot-fill').forEach(function (fill) { fill.getAnimations().forEach(function (animation) { animation.pause(); }); }); clearInterval(timer); timer = null; clearTimeout(resumeT); }
  function scheduleResume(delay) {
    clearTimeout(resumeT);
    resumeT = setTimeout(function () { paint(); reset(); }, delay || 4000);
  }
  var prev = root.querySelector('.carni-hero__nav--prev'), next = root.querySelector('.carni-hero__nav--next');
  if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
  if (next) next.addEventListener('click', function () { go(i + 1); reset(); });

  // --- swipe / drag (touch + mouse via pointer events) ---
  var track = root.querySelector('.carni-hero__track') || root;
  if (slides.length > 1) {
    var startX = 0, startY = 0, dragging = false, moved = false;
    var THRESHOLD = 45;
    function down(e) {
      pause();
      // Don't hijack drags that start inside a horizontally-scrolling card row
      // (promo / new-in slides), let that row scroll on its own; just hold the timer.
      if (e.target && e.target.closest && e.target.closest('.carni-hero__cards')) { dragging = false; scheduleResume(4000); return; }
      var p = (e.touches && e.touches[0]) || e;
      startX = p.clientX; startY = p.clientY; dragging = true; moved = false;
    }
    function move(e) {
      if (!dragging) return;
      var p = (e.touches && e.touches[0]) || e;
      if (Math.abs(p.clientX - startX) > 8) moved = true;
    }
    function up(e) {
      if (!dragging) { scheduleResume(4000); return; }
      dragging = false;
      var p = (e.changedTouches && e.changedTouches[0]) || e;
      var dx = p.clientX - startX, dy = p.clientY - startY;
      if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        go(dx < 0 ? i + 1 : i - 1); reset();
      } else {
        scheduleResume(3000);
      }
    }
    // Momentum scrolling in a card row keeps firing scroll events after the finger lifts:
    // keep pushing the resume out until the row settles.
    root.querySelectorAll('.carni-hero__cards').forEach(function (row) {
      row.addEventListener('scroll', function () { pause(); scheduleResume(4000); }, { passive: true });
    });
    track.addEventListener('touchstart', down, { passive: true });
    track.addEventListener('touchmove', move, { passive: true });
    track.addEventListener('touchend', up);
    track.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    // Suppress the click that follows a real drag so links don't fire mid-swipe.
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.style.cursor = 'grab';
  }

  function syncPlayback() { pause(); if (!motion.matches && !document.hidden && inView) { paint(); reset(); } }
  motion.addEventListener('change', syncPlayback);
  document.addEventListener('visibilitychange', syncPlayback);
  root.addEventListener('focusin', pause);
  root.addEventListener('focusout', function (event) { if (!root.contains(event.relatedTarget)) scheduleResume(4000); });
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      syncPlayback();
    }, { threshold: 0 });
    observer.observe(root);
  }
  if (slides.length > 1) { paint(); reset(); }
  else { dotsWrap.style.display = 'none'; if (prev) prev.style.display = 'none'; if (next) next.style.display = 'none'; }
});
